export async function askGroq({ messages, temperature = 0.3 }) {
  const GROQ_API_KEY = process.env.REACT_APP_GROQ_API_KEY;

  const res = await fetch(
    "https://api.groq.com/openai/v1/chat/completions",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${GROQ_API_KEY}`,
      },
      body: JSON.stringify({
        model: "llama-3.3-70b-versatile",
        messages: messages.map(m => ({
          role: m.role,
          content: m.content   // IMPORTANT FIX
        })),
        temperature,
      }),
    }
  );

  const data = await res.json();

  if (!res.ok) {
    console.error("GROQ ERROR:", data);
  }

  return data.choices?.[0]?.message?.content;
}